import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PelaajatComApp from "./PelaajatComApp";
import reportWebVitals from './reportWebVitals';
import * as Comlink from "comlink";

window.WebsiteApi = Comlink.wrap(new Worker(new URL('./WebsiteApi.js',import.meta.url)));

const initializeApp = () => {
    ReactDOM.createRoot(document.getElementById('root')).render(
        <React.StrictMode>
            <PelaajatComApp />
        </React.StrictMode>
    );
};
if (document.readyState !== 'loading') {
    initializeApp();
} else {
    document.addEventListener('DOMContentLoaded', initializeApp);
}

// @see https://bit.ly/CRA-vitals
reportWebVitals(console.log);
